// Administration.js
import React from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from 'antd';
import Users from './Users';
import AuditTrail from './AuditTrail';
import DocumentSettings from '../DocumentSettings';
import Roles from './Roles';
import { PageHeader } from '../common';

function Administration() {
  const location = useLocation();
  const navigate = useNavigate();

  // Determine active tab from current path
  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes('/users')) return 'users';
    if (path.includes('/roles')) return 'roles';
    if (path.includes('/document-settings')) return 'document-settings';
    if (path.includes('/audit-trail')) return 'audit-trail';
    return 'users';
  };

  // Tab items
  const tabItems = [
    {
      key: 'users',
      label: 'Users',
    },
    {
      key: 'roles',
      label: 'Roles',
    },
    {
      key: 'document-settings',
      label: 'Document Settings',
    },
    {
      key: 'audit-trail',
      label: 'Audit Trail',
    },
  ];

  const handleTabChange = (key) => {
    navigate(`/administration/${key}`);
  };

  return (
    <>
      <PageHeader
        title="Administration"
        breadcrumbs={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'Administration' }
        ]}
      />

      <Tabs
        activeKey={getActiveTab()}
        items={tabItems}
        onChange={handleTabChange}
        style={{ marginBottom: '24px' }}
      />

      <Routes>
        <Route index element={<Navigate replace to="users" />} />
        <Route path="users" element={<Users />} />
        <Route path="roles" element={<Roles />} />
        <Route path="document-settings" element={<DocumentSettings />} />
        <Route path="audit-trail" element={<AuditTrail />} />
      </Routes>
    </>
  );
}

export default Administration;
